// Приемане на оферта (РЪЧЕН режим на плащане): парите НЕ минават през
// платформата. Наемодателят възлага работата; плаща на майстора ДИРЕКТНО
// (по банка или в брой) след като и двете страни потвърдят готовия ремонт.
// Приложението проследява целия статус и пази историята.

import React, { useState } from 'react';
import { api, money } from '../../api';
import { showError, showSuccess } from '../../toast';
import { Button, Card, Muted, Row, Screen, Title } from '../../ui';
import { t } from '../../i18n';

export default function HoldPaymentScreen({ route, navigation }: any) {
  const { offerId, amountCents, handyman, description } = route.params;
  const [loading, setLoading] = useState(false);

  const accept = async () => {
    setLoading(true);
    try {
      await api(`/jobs/offers/${offerId}/accept`, { body: {} });
      showSuccess(t('Офертата е приета — майсторът е уведомен. Плащате му директно след двойното потвърждение.'));
      navigation.goBack();
    } catch (e: any) {
      showError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Screen>
      <Title>{t('Възлагане на ремонта')}</Title>
      <Card>
        <Row left={t('Майстор')} right={handyman} />
        <Row left={t('Работа')} right={description} />
        <Row left={t('Договорена сума')} right={money(amountCents)} />
        <Muted>
          {t('Как работи: майсторът извършва ремонта и качва снимка; след като и вие (и наемателят, ако има) потвърдите готовата работа, плащате му {amount} директно — по банка или в брой. При несъгласие се отваря спор към модератор.', { amount: money(amountCents) })}
        </Muted>
      </Card>

      <Button title={t('Възложи за {amount}', { amount: money(amountCents) })} onPress={accept} loading={loading} />
    </Screen>
  );
}
